<template>
  <div>
    <div class="contact">
      <div class="form">
        <div class="container">
          <div class="logo">
            <a href="#" class="logo-link">
            <img src="/static/images/torepi-logo.png" alt="" class="mb-4 logo-img">
            </a>
          </div>
          <div class="contact-box">
            <div style="z-index: 111;background: #fff;border-radius: 19px;position: relative;">
              <div class="title-box">
                <h2 class="pri-title">お問い合わせ</h2>
              </div>
              <form class="contact-box--form">
                <b-row>
                  <b-col cols="12" md="6">
                    <div class="form-group">
                      <label for="" class="label-form">お名前<span class="required">*</span></label>
                      <div class="input-group">
                        <input type="text" id="" name="username" class="input-form" :class="{error:!$v.params.name.required && invalid}" placeholder="お名前を入力してください" v-model="params.name">
                        <small v-if="!$v.params.name.required && invalid" class="text-input error">{{message.NAME_REQUIRED}}</small>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="request" class="label-form">会社名<span class="required">*</span></label>
                      <div class="input-group">
                        <input type="text" id="request" name="username" class="input-form" :class="{error:!$v.params.company_name.required && invalid}"  placeholder="会社名を入力してください" v-model="params.company_name">
                        <small v-if="!$v.params.company_name.required && invalid" class="text-input error">{{message.COMPANY_NAME_REQUIRED}}</small>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="email" class="label-form">メールアドレス<span class="required">*</span></label>
                      <div class="input-group">
                        <input type="text" id="email" name="email" class="input-form" placeholder="メールアドレスを入力してください" :class="emailError()" v-model.trim="params.email">
                        <small v-if="!$v.params.email.required && invalid" class="text-input error">{{message.EMAIL_REQUIRED}}</small>
                        <small v-if="!$v.params.email.valid && invalid && $v.params.email.required" class="text-input error">{{message.EMAIL_FORMAT}}</small>
                        <small v-if="errorContact.email" class="text-input error">{{validateEmail(errorContact.email[0])}}</small>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="phone" class="label-form">電話番号<span class="required">*</span></label>
                      <div class="input-group">
                        <input type="text" id="phone" name="phone" class="input-form" :class="phoneError()" placeholder="電話番号を入力してください" v-model="params.phone">
                        <small v-if="!$v.params.phone.required && invalid" class="text-input error">{{message.PHONE_REQUIRED}}</small>
                        <small v-if="!$v.params.phone.valid && invalid && $v.params.phone.required" class="text-input error">{{message.PHONE_FORMAT}}</small>
                      </div>
                    </div>
                  </b-col>
                  <b-col cols="12" md="6">
                    <div class="form-group">
                      <label for="username" class="label-form">要件<span class="required">*</span></label>
                      <div class="input-group">
                        <input type="text" id="username" name="username" class="input-form" placeholder="要件を入力してください" :class="{error: !$v.params.requirement.required && invalid}" v-model="params.requirement">
                        <small v-if="!$v.params.requirement.required && invalid" class="text-input error">{{message.REQUIREMENT_REQUIRED}}</small>
                      </div>
                    </div>
                    <div class="form-group">
                      <label for="username" class="label-form">内容<span class="required">*</span></label>
                      <div class="input-group">
                        <textarea rows="4" placeholder="内容を入力してください" class="input-form textarea" :class="{error: !$v.params.content.required && invalid}" v-model="params.content"></textarea>
                        <small v-if="!$v.params.content.required && invalid" class="text-input error">{{message.CONTENT_REQUIRED}}</small>
                      </div>
                    </div>
                  </b-col>
                </b-row>
                <div class="button-group">
                  <button class="btn btn-rounder btn-primary btn-contact" type="button" @click="registerContact">送信</button>
                </div>
                <div class="form-footer text-center">
                  <p class="text">すでにアカウントをお持ちですか？ <a class="link"><router-link :to="{name: 'login'}">ここでログイン。</router-link></a></p>
                </div>
              </form>
            </div>
            <div class="contact-1">
              <img src="@img/contact-3.svg" />
            </div>
            <div class="contact-2">
              <img src="@img/contact-1.svg" />
            </div>
            <div class="contact-3">
              <img src="@img/contact-2.svg" />
            </div>
          </div>
          <div class="copyright">
            <span>株式会社SOFTNEXT©2020 All rights reserved</span>
          </div>
        </div>
      </div>
    </div>
    <div class="modalUser">
      <b-modal id="modalContact" ref="modalContact" modal-class="modalsmall" centered no-close-on-backdrop>
        <template v-slot:modal-header>
          <!-- Emulate built in modal header close button action -->
          <div class="title-modal text-center w-100">
            <h2 class="title text-uppercase">通知</h2>
            <p class="sub-title">お問い合わせを送信しました。</p>
          </div>
        </template>
        <div class="modalUser--main">
        <div class="imageDeleteUser">
          <img src="@img/contact-modal.svg" alt="" class="img-fluid">
        </div>
        </div>
        <template v-slot:modal-footer>
          <div class="w-100 button-group">
            <button
              class="btn btn-rounder btn-primary btn-contact w-100"
              type="button" @click="contactComplete">ログインページへ</button>
          </div>
        </template>
      </b-modal>
    </div>
    <div class="modalUser">
      <b-modal id="modalError" ref="modalError" modal-class="modalsmall" centered no-close-on-backdrop>
        <template v-slot:modal-header>
          <div class="title-modal text-center w-100">
            <h2 class="title text-uppercase">通知</h2>
            <p class="sub-title">サーバーで一時的なエラーが発生し、リクエストを完了できませんでした。</p>
          </div>
        </template>
        <div class="modalUser--main">
          <div class="imageDeleteUser">
            <img src="@img/contact-modal.svg" alt="" class="img-fluid">
          </div>
        </div>
        <template v-slot:modal-footer>
          <div class="w-100 button-group">
            <button
              class="btn btn-rounder btn-primary btn-contact w-100"
              type="button" @click="closeErrorModal">わかった</button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
import {mapState} from 'vuex'
import {required} from 'vuelidate/lib/validators'
import {MESSAGE} from '../../utils/errorjapanese'
import errorMessage from '../../utils/errormessage'

export default {
  name: 'Contact',
  data () {
    return {
      params: {
        name: '',
        company_name: '',
        email: '',
        phone: '',
        requirement: '',
        content: ''
      },
      invalid: false,
      message: MESSAGE
    }
  },
  watch: {
    'params.email' () {
      this.$store.commit('allAuth/CHANGE_ERROR_CONTACT', '')
    }
  },
  validations: {
    params: {
      email: {
        required,
        valid (email) {
          const validate = /^[[a-zA-Z][a-zA-Z0-9_.-]{1,32}@[a-z0-9_-]{2,}(\.[a-z0-9]{2,}){1,}$/.test(email)
          return validate
        }
      },
      phone: {
        required,
        valid (phone) {
          const validate = /^[0-9-.+]{3,20}$/i.test(phone)
          return validate
        }
      },
      requirement: {
        required
      },
      content: {
        required
      },
      name: {
        required
      },
      company_name: {
        required
      }
    }
  },
  components: {
    'b-modal': BModal
  },
  directives: {
    'b-modal': VBModal
  },
  methods: {
    registerContact (e) {
      e.preventDefault()
      this.invalid = this.$v.$invalid
      if (this.invalid) {
        this.$v.$touch()
        return
      }
      this.$store.dispatch('allAuth/registerContact', {params: this.params, callback: {onSuccess: this.registerSuccess, onError: this.enailFailed}})
      // this.$root.$emit('bv::show::modal', 'modalContact', '#modalContact')
    },
    registerSuccess () {
      this.$refs['modalContact'].show()
    },
    enailFailed () {
      this.$refs['modalError'].show()
    },
    closeErrorModal () {
      this.$refs['modalError'].hide()
    },
    contactComplete () {
      this.params.name = ''
      this.params.phone = ''
      this.params.requirement = ''
      this.params.email = ''
      this.params.content = ''
      this.params.company_name = ''
      this.$refs['modalContact'].hide()
      this.$router.push('/')
    },
    phoneError () {
      return (!this.$v.params.phone.valid || !this.$v.params.phone.required) && this.invalid ? 'error' : ''
    },
    emailError () {
      return ((!this.$v.params.email.valid || !this.$v.params.email.required) && this.invalid) || this.errorContact.email ? 'error' : ''
    },
    validateEmail (value) {
      return errorMessage.errorEmail(value)
    }
  },
  computed: {
    ...mapState({
      errorContact: state => state.allAuth.errorContact
    })
  }
}
</script>
<style scoped lang='scss'>
@import '@/assets/stylesheet/auth/contact.scss';
textarea::-webkit-input-placeholder {
  line-height: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Contact/FormContact.vue